import BaseModel from './BaseModel'

export default class Deal extends BaseModel {
  // ... any Deal-specific methods or overrides ...
}
